/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/22/14
 * Time: 11:43 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var PersonalizationWidgetModel = {};

    LE.module("LEPersonalization", function (LEConnection, LE, Backbone, Marionette, $, _) {
        PersonalizationWidgetModel = Backbone.Model.extend({
            defaults: {
                featuresByRoutCount:0
            },
            name: "PersonalizationWidgetModel"
        });
    });
    return PersonalizationWidgetModel;
});
